import React from 'react';
import { Loader2 } from 'lucide-react';

const css = `
.cl-toggle-switch { position: relative; }
.cl-switch { position: relative; display: inline-block; }
.cl-switch > input {
  appearance: none; -moz-appearance: none; -webkit-appearance: none;
  z-index: -1; position: absolute; right: 6px; top: -8px;
  display: block; margin: 0; border-radius: 50%;
  width: 40px; height: 40px;
  background-color: rgba(0,0,0,0.38);
  outline: none; opacity: 0; transform: scale(1);
  pointer-events: none;
  transition: opacity 0.3s 0.1s, transform 0.2s 0.1s;
}
.cl-switch > span::before {
  content: ""; float: right; display: inline-block;
  margin: 5px 0 5px 10px; border-radius: 7px;
  width: 36px; height: 14px;
  background-color: rgba(0,0,0,0.38);
  vertical-align: top;
  transition: background-color 0.2s, opacity 0.2s;
}
.cl-switch > span::after {
  content: ""; position: absolute; top: 2px; right: 16px;
  border-radius: 50%; width: 20px; height: 20px;
  background-color: #fff;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,0.2), 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12);
  transition: background-color 0.2s, transform 0.2s;
}
.cl-switch > input:checked { right: -10px; background-color: rgba(37,99,235,0.3); }
.cl-switch > input:checked + span::before { background-color: rgba(37,99,235,0.4); }
.cl-switch > input:checked + span::after { background-color: #2563EB; transform: translateX(16px); }
.cl-switch:hover > input { opacity: 0.04; }
.cl-switch > input:focus { opacity: 0.12; }
.cl-switch:hover > input:focus { opacity: 0.16; }
.cl-switch > input:active { opacity: 1; transform: scale(0); transition: transform 0s, opacity 0s; }
.cl-switch > input:active + span::before { background-color: #8f8f8f; }
.cl-switch > input:checked:active + span::before { background-color: rgba(37,99,235,0.4); }
.cl-switch > input:disabled { opacity: 0; }
.cl-switch > input:disabled + span::before { background-color: #ddd; }
.cl-switch > input:checked:disabled + span::before { background-color: rgba(37,99,235,0.2); }
.cl-switch > input:checked:disabled + span::after { background-color: #93b4f7; }
`;

let injected = false;

const ServiceToggle = ({ checked, onChange, disabled = false, loading = false }) => {
  if (!injected && typeof document !== 'undefined') {
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    injected = true;
  }

  if (loading) {
    return (
      <div className="inline-flex items-center justify-center" style={{ width: 46, height: 24 }}>
        <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
      </div>
    );
  }

  return (
    <div className="cl-toggle-switch" onClick={(e) => e.stopPropagation()}>
      <label className="cl-switch" style={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1 }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => !disabled && onChange(e.target.checked)}
          disabled={disabled}
        />
        <span />
      </label>
    </div>
  );
};

export default ServiceToggle;
